import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'
import {
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CHeader, CContainer, CHeaderNav, CNavItem, CNavLink,
    CTable,
    CTableBody,
    CTableDataCell,
    CTableHead,
    CTableHeaderCell,
    CTableRow,
    CModal, CModalBody, CModalFooter, CModalHeader, CFormInput,
    CFormTextarea
} from '@coreui/react'
import { getUserIdFromToken } from '../../../utils/authUtils';
import PhoneInput from 'react-phone-input-2';
import { format } from "date-fns";
import 'react-phone-input-2/lib/style.css';
import monday from '../billingmanagement/caisiere/pictures/momo.png'; // Mobile money icon
import money from '../billingmanagement/caisiere/pictures/Money.png'; // Card payment icon
import { FaSearch, FaReceipt } from "react-icons/fa";
import { BsPersonPlus, BsChevronRight, BsPlayCircle, BsHeartPulse, BsEye, BsPencilSquare, BsTrash } from 'react-icons/bs';
import '../../../assets/css/mainstyle.css';
import '../../../assets/css/ClientSidebar.css';
import AddAppointmentModal from '../appointmentmanagment/addappointment'; // Le composant modal
import Adminprofil from '../../../assets/images/adminprofil.png';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import api from '../../../service/caller';
import { ToastContainer, toast } from 'react-toastify';
import { usePermissions } from '../../../contexts/PermissionContext';
import DoctorAppointment from '../../Doctorinterface/appointment';
import EditAppointmentModal from './editappointment';


const AppointmentList = () => {

    const [UserData, setUserData] = useState([]);
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [appointments, setAppointments] = useState([]);
    const [patients, setPatients] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [totalPatients, setTotalPatients] = useState(0);
    const [loadingg, setLoading] = useState(false);
    const limit = 10; // Nombre de patients par page
    const [showsignvitalModal, setShowSignvitalModal] = useState(false);
    const [departments, setDepartments] = useState([]);
    const { hasPermission, loading } = usePermissions();
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [cancelReason, setCancelReason] = useState('');
    const [selectedAppointment, setSelectedAppointment] = useState(null);
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [appointmentIdToEdit, setAppointmentIdToEdit] = useState(null);
    const [activeTab, setActiveTab] = useState('active'); // 'active' ou 'archived'
    const [archivedAppointments, setArchivedAppointments] = useState([]);
    const [filteredArchivedAppointments, setFilteredArchivedAppointments] = useState([]);
    const [currentArchivedPage, setCurrentArchivedPage] = useState(1);

    const location = useLocation();
    useEffect(() => {
        // Récupérer le token depuis l'URL
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        const showModal = urlParams.get('showModal'); // Vérifier si `showModal=true`

        // Si le token existe, on le stocke dans localStorage
        if (token) {
            localStorage.setItem('access_token', token);
            // Supprimer le token de l'URL pour qu'il ne reste pas visible
            window.history.replaceState({}, document.title, window.location.pathname);
        }

        // Afficher le modal si showModal est égal à 'true'
        if (showModal === 'true') {
            setVisible(true);
        }
    }, [location.search]);

    // Handle the viewing of appointment details
    const handleViewDetails = () => {
        setShowDetailsModal(true);
    };
    const [cardNumber, setCardNumber] = useState('');
    const [cardExpiry, setCardExpiry] = useState('');
    const [cardCVC, setCardCVC] = useState('');
    const [showPenaltyWarningModal, setShowPenaltyWarningModal] = useState(false);
    const [penaltyAmount, setPenaltyAmount] = useState(0);
    const [appointmentsPerPage] = useState(10);
    const [filteredAppointments, setFilteredAppointments] = useState([]);
    const [systemSettings, setSystemSettings] = useState({
        cancellationPenaltyPercentage: 30, // Default value, will be fetched from settings
        minimumCancellationHours: 48 // Default value, will be fetched from settings
    });

    const [paymentMethod, setPaymentMethod] = useState('mobile-money');
    const [phone, setPhoneNumber] = useState('');
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [isProcessingPayment, setIsProcessingPayment] = useState(false);

    // Function to handle payment method selection
    const handlePaymentMethodSelect = (method) => {
        setPaymentMethod(method);
    };

    // Function to handle mobile money payment confirmation
    const handleMomoPaymentConfirmation = async () => {
        if (paymentMethod === 'mobile-money' && !phone) {
            toast.error('Veuillez entrer votre numéro de téléphone');
            return;
        }

        setIsProcessingPayment(true);

        try {
            // Call payment processing API
            const paymentResponse = await api.post(`/payment/paymentmomo/initiate`, {
                item_name: 'Cancel appointment Payment',
                motifId: selectedAppointment._id,
                currency: 'USD',
                amount: penaltyAmount,
                paymentMethod: paymentMethod,
                payerMessage: "Excuse",
                phoneNumber: phone,
                paymentReason: 'Cancel appointment',
            });

            if (paymentResponse.status === 200) {
                // Payment successful, now proceed with cancellation
                console.log("dkjfk", selectedAppointment)
                //add billing
                const paymentData = {
                    operationtype: 'Delete Appointment',
                    OperationId: selectedAppointment._id,
                    operationRef: "Appointment",
                    operationcode: selectedAppointment.AppointmentCode,
                    paymentuniqueId: paymentResponse?.data?.paymentResponse?.referenceId,
                    caissiereId: getUserIdFromToken(),
                    patientId: selectedAppointment.patientId,
                    amount: penaltyAmount,
                    currency: 'FCFA',
                    purpose: 'Consultation Fee',
                    department: selectedAppointment.department,
                    hospitalId: selectedAppointment.hospitalId
                };

                const paymentResponsed = await api.post('/clinic/createPayment', paymentData);
                // setPaymentdetails(paymentResponse.data.payment);
                const paymentstatus = true;
                const currency = paymentData.currency;
                const montantrestant = 0;
                const montantpaye = penaltyAmount;
                const paymentInfo = await api.put(`clinic/billing/updatepaystatus/${paymentResponsed?.data.billing._id}`, { paymentstatus: paymentstatus, paymentMethod, currency, montantrestant, montantpaye, caissiereId: getUserIdFromToken() });

                setShowPaymentModal(false);
                setShowCancelModal(true);
                toast.success('Paiement traité avec succès');
            } else {
                toast.error('Le traitement du paiement a échoué');
            }
        } catch (error) {
            console.error('Erreur lors du traitement du paiement:', error);
            toast.error('Le traitement du paiement a échoué: ' + (error.response?.data?.message || 'Erreur inconnue'));
        } finally {
            setIsProcessingPayment(false);
        }
    };

    const fetchArchivedAppointments = async () => {
        try {
            const token = localStorage.getItem('access_token');
            if (!token) {
                throw new Error('Token not found');
            }

            const hospitalIds = Array.isArray(UserData.hospital_id) ? UserData.hospital_id : [UserData.hospital_id];

            // Créez une requête pour chaque hospitalId
            const promises = hospitalIds.map(hospitalId =>
                api.get(`/clinic/getArchivedAppointmentlist?hospitalId=${hospitalId._id || hospitalId}`, {
                    headers: { Authorization: `Bearer ${token}` }
                })
            );

            const responses = await Promise.all(promises);

            // Combiner toutes les données des réponses
            const allArchivedAppointments = responses.flatMap(response => response.data);

            setArchivedAppointments(allArchivedAppointments);

            // Filtrer les rendez-vous selon l'utilisateur
            if (UserData.role && UserData.role.name === 'medtinz_client_patient') {
                const patientResponse = await api.get('/clinic/getPatientByUserId', {
                    headers: { Authorization: `Bearer ${token}` }
                });

                const patientId = patientResponse.data._id;
                const filteredArchivedApps = allArchivedAppointments.filter(appointment =>
                    appointment.patientId._id === patientId
                );

                setArchivedAppointments(filteredArchivedApps);
            }
        } catch (error) {
            console.error('Error fetching archived appointments:', error);
            toast.error("Failed to fetch archived appointments");
        }
    };

    useEffect(() => {
        if (activeTab === 'archived' && UserData && UserData.hospital_id) {
            fetchArchivedAppointments();
        }
    }, [activeTab, UserData]);

    // Effet pour filtrer les rendez-vous archivés
    useEffect(() => {
        const results = archivedAppointments.filter(appointment =>
            (appointment.AppointmentCode && appointment.AppointmentCode.toLowerCase().includes(searchTerm)) ||
            (appointment.patientId?.firstname && appointment.patientId.firstname.toLowerCase().includes(searchTerm)) ||
            (appointment.patientId?.lastname && appointment.patientId.lastname.toLowerCase().includes(searchTerm)) ||
            (appointment.patientId?.phone && appointment.patientId.phone.includes(searchTerm))
        );
        setFilteredArchivedAppointments(results);
        setCurrentArchivedPage(1); // Reset to first page when search changes
    }, [searchTerm, archivedAppointments]);

    // Calculs pour la pagination des archives
    const indexOfLastArchivedAppointment = currentArchivedPage * appointmentsPerPage;
    const indexOfFirstArchivedAppointment = indexOfLastArchivedAppointment - appointmentsPerPage;
    const currentArchivedAppointments = filteredArchivedAppointments.slice(
        indexOfFirstArchivedAppointment,
        indexOfLastArchivedAppointment
    );
    const totalArchivedPages = Math.ceil(filteredArchivedAppointments.length / appointmentsPerPage);

    // Fonction pour paginer les archives
    const paginateArchived = (pageNumber) => setCurrentArchivedPage(pageNumber);

    // Vérification et archivage automatique des rendez-vous passés
    const checkAndArchiveExpiredAppointments = async () => {
        try {
            const currentDate = new Date();
            const expiredAppointments = appointments.filter(appointment => {
                const appointmentDate = new Date(appointment.appointmentDate);
                return appointmentDate < currentDate && appointment.status === 'Scheduled';
            });

            if (expiredAppointments.length > 0) {
                const appointmentIds = expiredAppointments.map(appointment => appointment._id);

                const response = await api.put('/clinic/archive-appointments', {
                    appointmentIds,
                }, {
                    headers: { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
                });

                if (response.status === 200) {
                    // Mettre à jour l'état local
                    setAppointments(prevAppointments =>
                        prevAppointments.map(app =>
                            appointmentIds.includes(app._id)
                                ? { ...app, status: 'Archived' }
                                : app
                        )
                    );
                    toast.info(`${expiredAppointments.length} rendez-vous expirés ont été archivés`);
                }
            }
        } catch (error) {
            console.error("Erreur lors de l'archivage des rendez-vous:", error);
        }
    };

    // Exécuter la vérification d'archivage après avoir chargé les rendez-vous
    useEffect(() => {
        if (appointments.length > 0) {
            checkAndArchiveExpiredAppointments();
        }
    }, [appointments]);
    // Add this effect to fetch system settings
    useEffect(() => {
        const fetchSystemSettings = async () => {
            try {
                const response = await api.get('/clinic/system-settings');
                if (response.data) {
                    setSystemSettings({
                        cancellationPenaltyPercentage: response.data.cancellationPenaltyPercentage || 30,
                        minimumCancellationHours: response.data.minimumCancellationHours || 48
                    });
                }
            } catch (error) {
                console.error('Error fetching system settings:', error);
            }
        };

        fetchSystemSettings();
    }, []);

    // Modify the handleOpenCancelModal function
    const handleOpenCancelModal = async (appointmentId) => {
        try {
            // Get the appointment details
            // const appointmentResponse =  await api.get(`/clinic/appointments/${appointmentId}`);
            const appointment = appointments.filter(apt => apt._id === appointmentId._id)[0];

            // Get the current time and appointment time
            const currentTime = new Date();
            const appointmentTime = new Date(appointment.appointmentDate);

            // Calculate the difference in hours
            const hoursDifference = (appointmentTime - currentTime) / (1000 * 60 * 60);

            // Check if the appointment is within the penalty period
            if (hoursDifference < systemSettings.minimumCancellationHours && UserData?.role?.name === "medtinz_client_patient") {
                // Calculate penalty amount (assuming we have appointment price info)
                const appointmentPrice = appointment.price || 0;
                const calculatedPenalty = (appointmentPrice * systemSettings.cancellationPenaltyPercentage) / 100;

                setPenaltyAmount(calculatedPenalty);
                setSelectedAppointment(appointmentId);
                setShowPenaltyWarningModal(true);
            } else {
                // No penalty, proceed with normal cancellation
                setSelectedAppointment(appointmentId);
                setShowCancelModal(true);
            }
        } catch (error) {
            console.error('Error checking appointment time:', error);
            toast.error('Error processing your request');
        }
    };

    // Add this function to handle confirmation of cancellation with penalty
    const handleConfirmCancellationWithPenalty = () => {
        // Close the penalty warning modal and open the payment modal
        setShowPenaltyWarningModal(false);
        setShowPaymentModal(true);
    };

    // Modify the handleCancelAppointment function to include penalty information
    const handleCancelAppointment = async () => {
        if (!cancelReason) {
            toast.error('Please provide a reason for cancellation');
            return;
        }

        try {
            const token = localStorage.getItem('access_token');
            if (!token) {
                throw new Error('Token not found');
            }

            // Get the current time and appointment time
            const appointment = appointments.filter(apt => apt._id === selectedAppointment._id)[0];
            const currentTime = new Date();
            const appointmentTime = new Date(appointment.appointmentDate);
            const hoursDifference = (appointmentTime - currentTime) / (1000 * 60 * 60);

            // Calculate penalty if applicable
            let penalty = 0;
            let penaltyPaid = false;
            if (hoursDifference < systemSettings.minimumCancellationHours) {
                const appointmentPrice = appointment.price || 0;
                penalty = (appointmentPrice * systemSettings.cancellationPenaltyPercentage) / 100;

                // Check if penalty has been paid - we can assume it has been if we reached this point after showing the payment modal
                penaltyPaid = true;
            }

            const response = await api.put(
                `/clinic/cancelappointments/${selectedAppointment._id}`,
                {
                    reasonForCancellation: cancelReason,
                    lateCancellation: hoursDifference < systemSettings.minimumCancellationHours,
                    penaltyAmount: penalty,
                    penaltyPaid: penaltyPaid
                },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.status === 200) {
                toast.success('Appointment cancelled successfully');

                // Update the appointments list to reflect the cancellation
                setAppointments(prevAppointments =>
                    prevAppointments.map(app =>
                        app._id === selectedAppointment._id
                            ? { ...app, status: 'Cancelled' }
                            : app
                    )
                );

                setShowCancelModal(false);
            } else {
                toast.error('Error cancelling appointment');
            }
        } catch (error) {
            console.error("Error cancelling appointment:", error);
            toast.error('Error cancelling appointment');
        }
    };

    // Function to process penalty payment
    const handleProcessPenaltyPayment = async () => {
        // Validate payment details
        if (paymentMethod === 'creditCard' && (!cardNumber || !cardExpiry || !cardCVC)) {
            toast.error('Please fill in all payment details');
            return;
        }

        setIsProcessingPayment(true);

        try {
            // Call payment processing API
            const paymentResponse = await api.post('/clinic/process-penalty-payment', {
                appointmentId: selectedAppointment._id,
                amount: penaltyAmount,
                paymentMethod,
                cardDetails: paymentMethod === 'creditCard' ? {
                    cardNumber,
                    cardExpiry,
                    cardCVC
                } : null
            });

            if (paymentResponse.status === 200) {
                // Payment successful, now proceed with cancellation
                setShowPaymentModal(false);
                setShowCancelModal(true);
                toast.success('Penalty payment processed successfully');
            } else {
                toast.error('Payment processing failed');
            }
        } catch (error) {
            console.error('Error processing payment:', error);
            toast.error('Payment processing failed: ' + (error.response?.data?.message || 'Unknown error'));
        } finally {
            setIsProcessingPayment(false);
        }
    };

    useEffect(() => {
        const fetchLoggedUserData = async () => {
            try {
                const response = await api.get('api/usersprofile');

                setUserData(response.data);
            } catch (error) {
                toast.error("Failed to fetch data");
            }
        };
        fetchLoggedUserData();
    }, []);


    // liste des appointments 
    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const token = localStorage.getItem('access_token');
                if (!token) {
                    throw new Error('Token not found');
                }

                const hospitalIds = Array.isArray(UserData.hospital_id) ? UserData.hospital_id : [UserData.hospital_id];

                // Créez une requête pour chaque hospitalId
                const promises = hospitalIds.map(hospitalId =>
                    api.get(`/clinic/getAppointmentlist?hospitalId=${hospitalId._id || hospitalId}`, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                );

                const responses = await Promise.all(promises);

                // Combiner toutes les données des réponses
                const allAppointments = responses.flatMap(response => response.data);

                // Ajouter la vérification des signes vitaux pour chaque rendez-vous
                const appointmentsWithSignVitalStatus = await Promise.all(
                    allAppointments.map(async (appointment) => {
                        const signVitalExists = await fetchSignVitalStatus(appointment._id);
                        return {
                            ...appointment,
                            signVitalExists,  // Ajout de la propriété `signVitalExists` à l'objet appointment
                        };
                    })
                );

                setAppointments(appointmentsWithSignVitalStatus?.filter(apt => apt.status !== "Archived"));

                // Filtrer les rendez-vous selon l'utilisateur
                if (UserData.role && UserData.role.name === 'medtinz_client_patient') {
                    const patientResponse = await api.get('/clinic/getPatientByUserId', {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    const patientId = patientResponse.data._id;
                    const filteredAppointments = appointmentsWithSignVitalStatus.filter(appointment =>
                        appointment.patientId._id === patientId
                    );

                    setAppointments(filteredAppointments);
                }
            } catch (error) {
                console.error('Error fetching appointments:', error);
                toast.error("Failed to fetch appointments");
            }
        };

        if (UserData && UserData.hospital_id) {
            fetchAppointments();
        }
    }, [UserData]);


    // listes des departments
    useEffect(() => {
        const fetchDepartments = async () => {
            try {
                const response = await api.get(`/api/departments`, {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
                    }
                });

                // Mettre à jour les départements dans l'état
                setDepartments(response.data.data);
            } catch (error) {
                console.error('Erreur lors de la récupération des départements:', error);
            }
        };
        fetchDepartments(); // Appel de la fonction pour récupérer les départements
    }, []);


    // search
    const handleSearchChange = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchTerm(value);
    };

    const [currentPage, setCurrentPage] = useState(1);

    // Add this useEffect to filter appointments whenever searchTerm changes
    useEffect(() => {
        const results = appointments.filter(appointment =>
            (appointment.AppointmentCode && appointment.AppointmentCode.toLowerCase().includes(searchTerm)) ||
            (appointment.patientId?.firstname && appointment.patientId.firstname.toLowerCase().includes(searchTerm)) ||
            (appointment.patientId?.lastname && appointment.patientId.lastname.toLowerCase().includes(searchTerm)) ||
            (appointment.patientId?.phone && appointment.patientId.phone.includes(searchTerm))
        );
        setFilteredAppointments(results);
        setCurrentPage(1); // Reset to first page when search changes
    }, [searchTerm, appointments]);

    // Calculate pagination information
    const indexOfLastAppointment = currentPage * appointmentsPerPage;
    const indexOfFirstAppointment = indexOfLastAppointment - appointmentsPerPage;
    const currentAppointments = filteredAppointments.slice(indexOfFirstAppointment, indexOfLastAppointment);
    const totalPages = Math.ceil(filteredAppointments.length / appointmentsPerPage);

    // Add pagination control function
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    // Fonction pour vérifier si des signes vitaux existent pour un rendez-vous
    const fetchSignVitalStatus = async (appointmentId) => {
        try {
            const response = await api.get(`/clinic/signvitalforappointment/${appointmentId}`);
            return response.data.signVitaldata;
        } catch (error) {
            console.error('Erreur lors de la vérification des signes vitaux:', error);
            return false; // En cas d'erreur, on suppose qu'il n'y a pas de signes vitaux
        }
    };


    const handleAddOrEditSignsVital = async (appointmentId) => {
        const existingSignsVital = await fetchSignVitalStatus(appointmentId);
        navigate(`/appointment/${appointmentId}/signvital`, {
            state: { existingSignsVital },  // Passer les signes vitaux existants dans l'état de navigation
        });
    };

    const handleAppointmentAdded = (newAppointment) => {
        setAppointments((prev) => [...prev, newAppointment]);
    };

    const handleEditClick = (appointmentId) => {
        setAppointmentIdToEdit(appointmentId);
        setIsModalVisible(true);
    };

    const handleModalClose = () => {
        setIsModalVisible(false);
        setAppointmentIdToEdit(null);
    };

    const handlePrintBillingTicket = (id) => {
        navigate(`/hospitaladmin/printbillingticket/${id}`);
    };


    return (
        <div className="dashboard-header" >
            <ToastContainer />
            {/* <div className='row px-4'>
                <div className='col-lg-4 mb-3'>
                    <div className="pagetittle">
                        <h4 className=' text-start'><b>Appointment Management</b></h4>
                    </div>
                </div>
                <div className='col-lg-4'></div>
                <div className='col-lg-4 mx-auto'>
                    <div className="d-flex justify-content-end gap-4">
                        <div>
                            <img src={UserData?.picture || Adminprofil} className='cardicon' alt="Consultation Icon" width={'50'} height={'50'} />
                        </div>
                        <div>
                            <span className="ms-2" style={{ color: 'black' }} >{UserData.firstname} {UserData.lastname}</span>
                            <p className="ms-2" style={{ color: 'black' }} >{UserData.role?.name}</p>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="hosp-profile-header" style={{ backgroundColor: 'var(--hosp-background-color)', border: "none" }}>
                <div className="hosp-header__content">
                    {/* Titre à gauche */}
                    <div className="hosp-header__title">
                        <h4 className="hosp-page__title"><b>Appointment Management</b></h4>
                    </div>

                    {/* Profil utilisateur à droite */}
                    <div className="hosp-user__profile">
                        {/* Indicateur de statut en ligne (optionnel) */}
                        <div className="hosp-status__indicator"></div>

                        <img src={UserData?.picture || Adminprofil} className='hosp-profile__image' alt="Consultation Icon"  />

                        <div className="hosp-user__details">
                            <span className="ms-2" style={{ color: 'black' }} >{UserData.firstname} {UserData.lastname}</span>
                            <p className="ms-2" style={{ color: 'black' }} >{UserData.role?.name}</p>
                        </div>
                    </div>
                </div>
            </div>


            {UserData.role && UserData.role.name === 'medtinz_client_doctor' ? (
                <>
                    <div>
                        <DoctorAppointment />
                    </div>
                </>
            ) : (
                <div className="Patientlist mt-4">
                    <div className='tabsection'>
                        <CRow>
                            <CCol xs={12}>
                                <CCard className="card mb-4 p-4">
                                    <CCardBody>
                                        <div className='tablist'>
                                            {/* Onglets pour basculer entre actifs et archivés */}
                                            <ul className="nav nav-tabs mb-4">
                                                <li className="nav-item">
                                                    <button
                                                        className={`nav-link ${activeTab === 'active' ? 'active' : ''}`}
                                                        onClick={() => setActiveTab('active')}
                                                    >
                                                        Rendez-vous actifs
                                                    </button>
                                                </li>
                                                <li className="nav-item">
                                                    <button
                                                        className={`nav-link ${activeTab === 'archived' ? 'active' : ''}`}
                                                        onClick={() => setActiveTab('archived')}
                                                    >
                                                        Rendez-vous archivés
                                                    </button>
                                                </li>
                                            </ul>

                                            <div className=''>
                                                <div className='row'>
                                                    <div className="col-lg-9 mb-4">
                                                        <div className="search-container w-100">
                                                            <div className="search-bar">
                                                                <FaSearch size="sm" className="search-icon " style={{ width: '20px', height: '20px' }} />
                                                                <input
                                                                    className='ms-4 w-100'
                                                                    type="text"
                                                                    placeholder="Search for a patient (Enter ID, name or Tel)"
                                                                    value={searchTerm}
                                                                    onChange={handleSearchChange}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-3 mb-4">
                                                        {activeTab === 'active' && (
                                                            <div className='registeruserbtn ms-auto'>
                                                                <CButton onClick={() => setVisible(true)}
                                                                    className="btn-primary"
                                                                    active tabIndex={-1}
                                                                    style={{
                                                                        backgroundColor: '#0056B3',
                                                                        color: 'white',
                                                                        width: '100%',
                                                                        padding: '10px 20px',
                                                                        borderRadius: '20px'
                                                                    }}
                                                                >
                                                                    <BsPersonPlus className='mx-2' /> Book Appointment
                                                                </CButton>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                <AddAppointmentModal
                                                    visible={visible}
                                                    onClose={() => setVisible(false)}
                                                    onAppointmentAdded={handleAppointmentAdded} />
                                            </div>

                                            <div className='patientlisttable'>
                                                {/* Afficher différentes tables selon l'onglet sélectionné */}
                                                {activeTab === 'active' ? (
                                                    <>
                                                        {/* Table des rendez-vous actifs (code existant) */}
                                                        <CTable className="mt-5 ctable-no-border " align="middle" responsive>
                                                            <CTableHead>
                                                                <CTableRow className='tablehead'>
                                                                    <CTableHeaderCell scope="col">AppointmentID</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Time</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Date</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Patient Name</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Phone</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Department</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Status</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Schedule type</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                                                                </CTableRow>
                                                            </CTableHead>
                                                            <CTableBody>
                                                                {currentAppointments.map((appointment) => (
                                                                    <CTableRow className="ctable-row" key={appointment._id} style={{
                                                                        background: appointment.type_consultation == "inperson" ? '#f8f9fa !important' : 'white !important'
                                                                    }}
                                                                    >
                                                                        <CTableDataCell>{appointment.AppointmentCode || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>{appointment.appointmentTime || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>
                                                                            {appointment.appointmentDate?.split("T")[0] || 'N/A'}
                                                                        </CTableDataCell>
                                                                        <CTableDataCell>{appointment.patientId?.firstname || 'Unknown'} {appointment.patientId?.lastname || 'Unknown'}</CTableDataCell>
                                                                        <CTableDataCell>{appointment.patientId?.phone || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell> {
                                                                            // Find the department name based on the department ID
                                                                            departments.find(department => department._id === appointment.department)?.name || 'N/A'
                                                                        }</CTableDataCell>
                                                                        <CTableDataCell>
                                                                            <span className={appointment.status === 'Scheduled' ? 'coloredsucess' : 'coloredechec'}>
                                                                                {appointment.status}
                                                                            </span>
                                                                        </CTableDataCell>
                                                                        <CTableDataCell>
                                                                            <span className={appointment.type_consultation === 'inperson' ? 'coloredsucess' : 'coloredechec'}>
                                                                                {appointment.type_consultation}
                                                                            </span>
                                                                        </CTableDataCell>
                                                                        {/* <CTableDataCell>
                                                                    <span className={appointment.status === 'Scheduled1' ? 'coloredsucess' : 'coloredechec'}>
                                                                        {appointment.type_consultation}
                                                                    </span>
                                                                </CTableDataCell> */}
                                                                        <CTableDataCell style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>

                                                                            {hasPermission('medtinz_client_patient_add_vital_sign') && (
                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={<Tooltip>{appointment.signVitalExists ? 'Edit Vital Signs' : 'Add Vital Signs'}</Tooltip>}
                                                                                >
                                                                                    <span
                                                                                        onClick={appointment.status !== 'Cancelled' && appointment.paymentStatus !== false ? () => handleAddOrEditSignsVital(appointment._id) : null}
                                                                                        style={{
                                                                                            color: appointment.signVitalExists ? '#198754' : '#0d6efd',
                                                                                            fontSize: '1.5rem',
                                                                                            cursor: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'default' : 'pointer',
                                                                                            pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                                                                                        }}
                                                                                    >
                                                                                        <BsHeartPulse />
                                                                                    </span>
                                                                                </OverlayTrigger>
                                                                            )}

                                                                            {hasPermission('medtinz_client_appointment_view') && (
                                                                                <OverlayTrigger placement="top" overlay={<Tooltip>View Details</Tooltip>}>
                                                                                    <span
                                                                                        onClick={appointment.status !== 'Cancelled' && appointment.paymentStatus !== false ? () => handleViewDetails(appointment._id) : null}
                                                                                        style={{
                                                                                            color: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? '#6c757d' : '#0dcaf0',
                                                                                            fontSize: '1.5rem',
                                                                                            cursor: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'default' : 'pointer',
                                                                                            pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                                                                                        }}
                                                                                    >
                                                                                        <BsEye />
                                                                                    </span>
                                                                                </OverlayTrigger>
                                                                            )}

                                                                            {
                                                                                hasPermission('medtinz_client_appointment_update') && (
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Edit Appointment</Tooltip>}>
                                                                                        <span
                                                                                            onClick={appointment.status !== 'Cancelled' && appointment.paymentStatus !== false ? () => handleEditClick(appointment) : null}
                                                                                            style={{
                                                                                                color: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? '#6c757d' : '#ffc107',
                                                                                                fontSize: '1.5rem',
                                                                                                cursor: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'default' : 'pointer',
                                                                                                pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                                                                                            }}
                                                                                        >
                                                                                            <BsPencilSquare />
                                                                                        </span>
                                                                                    </OverlayTrigger>
                                                                                )
                                                                            }

                                                                            <EditAppointmentModal
                                                                                visible={isModalVisible}
                                                                                onClose={handleModalClose}
                                                                                appointmentData={appointmentIdToEdit}
                                                                            />

                                                                            {
                                                                                hasPermission('medtinz_client_appointment_delete') && (
                                                                                    <OverlayTrigger placement="top" overlay={<Tooltip>Cancel Appointment</Tooltip>}>
                                                                                        <span
                                                                                            onClick={appointment.status !== 'Cancelled' && appointment.paymentStatus !== false ? () => handleOpenCancelModal(appointment) : null}
                                                                                            style={{
                                                                                                color: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? '#6c757d' : '#dc3545',
                                                                                                fontSize: '1.5rem',
                                                                                                cursor: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'default' : 'pointer',
                                                                                                pointerEvents: appointment.status === 'Cancelled' || appointment.paymentStatus === false ? 'none' : 'auto'
                                                                                            }}
                                                                                        >
                                                                                            <BsTrash />
                                                                                        </span>
                                                                                    </OverlayTrigger>
                                                                                )
                                                                            }

                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>Print Billing Ticket</Tooltip>}>
                                                                                <span
                                                                                    onClick={() => handlePrintBillingTicket(appointment._id)}
                                                                                    style={{
                                                                                        color: '#c594c5',
                                                                                        fontSize: '1.5rem',
                                                                                        cursor: 'pointer',
                                                                                        pointerEvents: 'auto'
                                                                                    }}
                                                                                >
                                                                                    <FaReceipt />
                                                                                </span>
                                                                            </OverlayTrigger>

                                                                            {/* Modal for Cancel Reason */}

                                                                            <CModal visible={showCancelModal} onClose={() => setShowCancelModal(false)}>
                                                                                <CModalHeader closeButton>
                                                                                    <h5>Cancel Appointment</h5>
                                                                                </CModalHeader>
                                                                                <CModalBody>
                                                                                    <CFormTextarea
                                                                                        type="text"
                                                                                        placeholder="Enter reason for cancellation"
                                                                                        value={cancelReason}
                                                                                        onChange={(e) => setCancelReason(e.target.value)}
                                                                                    />
                                                                                </CModalBody>
                                                                                <CModalFooter>
                                                                                    <CButton color="secondary" onClick={() => setShowCancelModal(false)}>
                                                                                        Close
                                                                                    </CButton>
                                                                                    <CButton color="danger" onClick={handleCancelAppointment}>
                                                                                        Cancel Appointment
                                                                                    </CButton>
                                                                                </CModalFooter>
                                                                            </CModal>

                                                                            <CModal visible={showPenaltyWarningModal} onClose={() => setShowPenaltyWarningModal(false)}>
                                                                                <CModalHeader closeButton>
                                                                                    <h5>Late Cancellation Warning</h5>
                                                                                </CModalHeader>
                                                                                <CModalBody>
                                                                                    <div className="alert alert-warning">
                                                                                        <p><strong>Warning:</strong> You are cancelling this appointment less than {systemSettings.minimumCancellationHours} hours before the scheduled time.</p>
                                                                                        <p>A cancellation penalty of {systemSettings.cancellationPenaltyPercentage}% will be applied.</p>
                                                                                        <p>Estimated penalty amount: {penaltyAmount.toFixed(2)}</p>
                                                                                    </div>
                                                                                    <p>Do you wish to proceed with the cancellation?</p>
                                                                                </CModalBody>
                                                                                <CModalFooter>
                                                                                    <CButton color="secondary" onClick={() => setShowPenaltyWarningModal(false)}>
                                                                                        No, Keep Appointment
                                                                                    </CButton>
                                                                                    <CButton color="danger" onClick={handleConfirmCancellationWithPenalty}>
                                                                                        Confirm and Accept Penalty
                                                                                    </CButton>
                                                                                </CModalFooter>
                                                                            </CModal>

                                                                            <CModal visible={showPaymentModal} onClose={() => setShowPaymentModal(false)} className="payment-gateway-modal">
                                                                                <CModalHeader closeButton className="modal-header1">
                                                                                    <h5>Paiement</h5>
                                                                                </CModalHeader>
                                                                                <CModalBody className="p-0">
                                                                                    <div className="ret">
                                                                                        <button
                                                                                            className="payment-gateway-modal-close"
                                                                                            onClick={() => setShowPaymentModal(false)}
                                                                                        >
                                                                                            ← Retour
                                                                                        </button>
                                                                                        <div className="paycontent">
                                                                                            <div className="alert alert-info mb-4">
                                                                                                <p>Pour annuler ce rendez-vous, vous devez d'abord payer la pénalité d'annulation de {penaltyAmount.toFixed(2)}.</p>
                                                                                            </div>

                                                                                            <h2 className="pinta">Choisissez votre méthode de paiement</h2>
                                                                                            <div className="payment-method-selection">
                                                                                                <label className="payment-method-radio">
                                                                                                    <input
                                                                                                        type="radio"
                                                                                                        name="payment-method"
                                                                                                        value="mobile-money"
                                                                                                        checked={paymentMethod === 'mobile-money'}
                                                                                                        onChange={() => handlePaymentMethodSelect('mobile-money')}
                                                                                                    />
                                                                                                    <img src={monday} alt="Mobile Money" className="monday" />
                                                                                                </label>
                                                                                                <label className="payment-method-radio">
                                                                                                    <input
                                                                                                        type="radio"
                                                                                                        name="payment-method"
                                                                                                        value="card"
                                                                                                        checked={paymentMethod === 'card'}
                                                                                                        onChange={() => handlePaymentMethodSelect('card')}
                                                                                                    />
                                                                                                    <img src={money} alt="Card Payment" className="money" />
                                                                                                </label>
                                                                                            </div>

                                                                                            {paymentMethod === 'mobile-money' && (
                                                                                                <div className="phone-input-container mobile-money-input">
                                                                                                    <label>Entrez votre numéro de téléphone</label>
                                                                                                    <PhoneInput
                                                                                                        country={'bj'}
                                                                                                        value={phone}
                                                                                                        onChange={(value) => setPhoneNumber(value)}
                                                                                                        name="phone"
                                                                                                        className="mx-auto"
                                                                                                    />
                                                                                                </div>
                                                                                            )}

                                                                                            {paymentMethod === 'card' && (
                                                                                                <>
                                                                                                    <div className="mb-3">
                                                                                                        <label className="form-label">Numéro de carte</label>
                                                                                                        <CFormInput
                                                                                                            type="text"
                                                                                                            placeholder="XXXX XXXX XXXX XXXX"
                                                                                                            value={cardNumber}
                                                                                                            onChange={(e) => setCardNumber(e.target.value)}
                                                                                                        />
                                                                                                    </div>

                                                                                                    <div className="row">
                                                                                                        <div className="col-md-6 mb-3">
                                                                                                            <label className="form-label">Date d'expiration</label>
                                                                                                            <CFormInput
                                                                                                                type="text"
                                                                                                                placeholder="MM/YY"
                                                                                                                value={cardExpiry}
                                                                                                                onChange={(e) => setCardExpiry(e.target.value)}
                                                                                                            />
                                                                                                        </div>

                                                                                                        <div className="col-md-6 mb-3">
                                                                                                            <label className="form-label">CVC</label>
                                                                                                            <CFormInput
                                                                                                                type="text"
                                                                                                                placeholder="123"
                                                                                                                value={cardCVC}
                                                                                                                onChange={(e) => setCardCVC(e.target.value)}
                                                                                                            />
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </>
                                                                                            )}

                                                                                            <div className="aladji">
                                                                                                <button
                                                                                                    onClick={paymentMethod === 'mobile-money' ? handleMomoPaymentConfirmation : handleProcessPenaltyPayment}
                                                                                                    disabled={(paymentMethod === 'mobile-money' && !phone) || isProcessingPayment}
                                                                                                    className="payment-confirm-button"
                                                                                                >
                                                                                                    {isProcessingPayment ? (
                                                                                                        <>
                                                                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                                                                                            Traitement...
                                                                                                        </>
                                                                                                    ) : (
                                                                                                        `Confirmer le Paiement (${penaltyAmount.toFixed(2)})`
                                                                                                    )}
                                                                                                </button>
                                                                                                <p className="vonvon">
                                                                                                    Vos données personnelles seront utilisées pour traiter votre commande, soutenir votre<br></br>
                                                                                                    expérience sur ce site Web et à d'autres fins décrites<br></br>
                                                                                                    dans notre politique de confidentialité.
                                                                                                </p>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </CModalBody>
                                                                            </CModal>
                                                                            {/* Modal for Viewing Appointment Details */}
                                                                            <CModal visible={showDetailsModal} onClose={() => setShowDetailsModal(false)}>
                                                                                <CModalHeader closeButton>
                                                                                    <h5>Appointment Details</h5>
                                                                                </CModalHeader>
                                                                                <CModalBody>
                                                                                    <p><strong>Patient Name:</strong> {appointment.patientId?.name}</p>
                                                                                    <p><strong>Doctor Name:</strong> {appointment.doctorId?.name}</p>
                                                                                    <p><strong>Appointment Date:</strong> {format(new Date(appointment?.appointmentDate), "yyyy-MM-dd")}</p>
                                                                                    <p><strong>Appointment Time:</strong> {appointment.appointmentTime}</p>
                                                                                    <p><strong>Purpose of Visit:</strong> {appointment.purposeOfVisit}</p>
                                                                                    <p><strong>Notes:</strong> {appointment.notes}</p>
                                                                                </CModalBody>
                                                                                <CModalFooter>
                                                                                    <CButton color="secondary" onClick={() => setShowDetailsModal(false)}>
                                                                                        Close
                                                                                    </CButton>
                                                                                </CModalFooter>
                                                                            </CModal>
                                                                        </CTableDataCell >
                                                                    </CTableRow >
                                                                ))}
                                                            </CTableBody >
                                                        </CTable >
                                                        <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center text-center mt-4 gap-3">
                                                            <div>
                                                                Showing {indexOfFirstAppointment + 1} to {Math.min(indexOfLastAppointment, filteredAppointments.length)} of {filteredAppointments.length} appointments
                                                            </div>
                                                            <div>
                                                                <nav>
                                                                    <ul className="pagination">
                                                                        {/* Bouton Previous */}
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage - 1)}>
                                                                                Previous
                                                                            </button>
                                                                        </li>

                                                                        {/* Logique d'affichage des numéros de page */}
                                                                        {(() => {
                                                                            const pageNumbers = [];
                                                                            const totalVisible = 5; // Nombre total de boutons de page visibles (sans compter Previous/Next)

                                                                            // Toujours afficher la première page
                                                                            if (currentPage > 3) {
                                                                                pageNumbers.push(
                                                                                    <li key={1} className="page-item">
                                                                                        <button onClick={() => paginate(1)} className="page-link">1</button>
                                                                                    </li>
                                                                                );

                                                                                // Ajouter des ellipses si nécessaire
                                                                                if (currentPage > 4) {
                                                                                    pageNumbers.push(
                                                                                        <li key="ellipsis1" className="page-item disabled">
                                                                                            <span className="page-link">...</span>
                                                                                        </li>
                                                                                    );
                                                                                }
                                                                            }

                                                                            // Calculer la plage des pages à afficher autour de la page courante
                                                                            const startPage = Math.max(1, currentPage - Math.floor((totalVisible - 3) / 2));
                                                                            const endPage = Math.min(totalPages, startPage + (totalVisible - 3));

                                                                            // Générer les boutons de page pour la plage calculée
                                                                            for (let i = startPage; i <= endPage; i++) {
                                                                                pageNumbers.push(
                                                                                    <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                                                                                        <button onClick={() => paginate(i)} className="page-link">{i}</button>
                                                                                    </li>
                                                                                );
                                                                            }

                                                                            // Ajouter des ellipses et la dernière page si nécessaire
                                                                            if (currentPage < totalPages - 2) {
                                                                                if (currentPage < totalPages - 3) {
                                                                                    pageNumbers.push(
                                                                                        <li key="ellipsis2" className="page-item disabled">
                                                                                            <span className="page-link">...</span>
                                                                                        </li>
                                                                                    );
                                                                                }

                                                                                pageNumbers.push(
                                                                                    <li key={totalPages} className="page-item">
                                                                                        <button onClick={() => paginate(totalPages)} className="page-link">{totalPages}</button>
                                                                                    </li>
                                                                                );
                                                                            }

                                                                            return pageNumbers;
                                                                        })()}

                                                                        {/* Bouton Next */}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                                Next
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                        </div>
                                                    </>
                                                ) : (
                                                    <>
                                                        {/* Table des rendez-vous archivés */}
                                                        <CTable className="mt-5 ctable-no-border " align="middle" responsive>
                                                            <CTableHead>
                                                                <CTableRow className='tablehead'>
                                                                    <CTableHeaderCell scope="col">AppointmentID</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Time</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Date</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Patient Name</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Phone</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Department</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Status</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Schedule type</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Archive Date</CTableHeaderCell>
                                                                    <CTableHeaderCell scope="col">Action</CTableHeaderCell>
                                                                </CTableRow>
                                                            </CTableHead>
                                                            <CTableBody>
                                                                {currentArchivedAppointments.map((appointment) => (
                                                                    <CTableRow className="ctable-row" key={appointment._id} style={{
                                                                        background: appointment.type_consultation == "inperson" ? '#f8f9fa !important' : 'white !important'
                                                                    }}>
                                                                        <CTableDataCell>{appointment.AppointmentCode || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>{appointment.appointmentTime || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>
                                                                            {appointment.appointmentDate?.split("T")[0] || 'N/A'}
                                                                        </CTableDataCell>
                                                                        <CTableDataCell>{appointment.patientId?.firstname || 'Unknown'} {appointment.patientId?.lastname || 'Unknown'}</CTableDataCell>
                                                                        <CTableDataCell>{appointment.patientId?.phone || 'N/A'}</CTableDataCell>
                                                                        <CTableDataCell>
                                                                            {departments.find(department => department._id === appointment.department)?.name || 'N/A'}
                                                                        </CTableDataCell>
                                                                        <CTableDataCell>
                                                                            <span className='coloredarchived'>
                                                                                {appointment.status}
                                                                            </span>
                                                                        </CTableDataCell>
                                                                        <CTableDataCell>
                                                                            <span className={appointment.type_consultation === 'inperson' ? 'coloredsucess' : 'coloredechec'}>
                                                                                {appointment.type_consultation}
                                                                            </span>
                                                                        </CTableDataCell>
                                                                        <CTableDataCell>
                                                                            {appointment.archivedAt?.split("T")[0] || 'N/A'}
                                                                        </CTableDataCell>
                                                                        <CTableDataCell style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                                                            <OverlayTrigger placement="top" overlay={<Tooltip>View Details</Tooltip>}>
                                                                                <span
                                                                                    onClick={() => handleViewDetails(appointment._id)}
                                                                                    style={{
                                                                                        color: '#0dcaf0',
                                                                                        fontSize: '1.5rem',
                                                                                        cursor: 'pointer'
                                                                                    }}
                                                                                >
                                                                                    <BsEye />
                                                                                </span>
                                                                            </OverlayTrigger>
                                                                            {/* Modal for Viewing Appointment Details */}
                                                                            <CModal visible={showDetailsModal} onClose={() => setShowDetailsModal(false)}>
                                                                                <CModalHeader closeButton>
                                                                                    <h5>Appointment Details</h5>
                                                                                </CModalHeader>
                                                                                <CModalBody>
                                                                                    <p><strong>Patient Name:</strong> {appointment.patientId?.firstname}</p>
                                                                                    <p><strong>Doctor Name:</strong> {appointment.doctorId?.firstname}</p>
                                                                                    <p><strong>Appointment Date:</strong> {format(new Date(appointment?.appointmentDate), "yyyy-MM-dd")}</p>
                                                                                    <p><strong>Appointment Time:</strong> {appointment.appointmentTime}</p>
                                                                                    <p><strong>Purpose of Visit:</strong> {appointment.purposeOfVisit}</p>
                                                                                    <p><strong>Notes:</strong> {appointment.notes}</p>
                                                                                </CModalBody>
                                                                                <CModalFooter>
                                                                                    <CButton color="secondary" onClick={() => setShowDetailsModal(false)}>
                                                                                        Close
                                                                                    </CButton>
                                                                                </CModalFooter>
                                                                            </CModal>
                                                                        </CTableDataCell>
                                                                    </CTableRow>
                                                                ))}
                                                            </CTableBody>
                                                        </CTable>

                                                        {/* Pagination pour les rendez-vous archivés */}
                                                        <div className="d-flex flex-column flex-md-row justify-content-center justify-content-md-between align-items-center text-center mt-4 gap-3">
                                                            <div>
                                                                Showing {indexOfFirstArchivedAppointment + 1} to {Math.min(indexOfLastArchivedAppointment, filteredArchivedAppointments.length)} of {filteredArchivedAppointments.length} archived appointments
                                                            </div>
                                                            <div>
                                                                <nav>
                                                                    <ul className="pagination">
                                                                        <li className={`page-item ${currentArchivedPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginateArchived(currentArchivedPage - 1)}>
                                                                                Previous
                                                                            </button>
                                                                        </li>

                                                                        {/* Logique similaire pour les numéros de page */}
                                                                        {(() => {
                                                                            const pageNumbers = [];
                                                                            const totalVisible = 5; // Nombre total de boutons de page visibles (sans compter Previous/Next)

                                                                            // Toujours afficher la première page
                                                                            if (currentArchivedPage > 3) {
                                                                                pageNumbers.push(
                                                                                    <li key={1} className="page-item">
                                                                                        <button onClick={() => paginate(1)} className="page-link">1</button>
                                                                                    </li>
                                                                                );

                                                                                // Ajouter des ellipses si nécessaire
                                                                                if (currentArchivedPage > 4) {
                                                                                    pageNumbers.push(
                                                                                        <li key="ellipsis1" className="page-item disabled">
                                                                                            <span className="page-link">...</span>
                                                                                        </li>
                                                                                    );
                                                                                }
                                                                            }

                                                                            // Calculer la plage des pages à afficher autour de la page courante
                                                                            const startPage = Math.max(1, currentArchivedPage - Math.floor((totalVisible - 3) / 2));
                                                                            const endPage = Math.min(totalArchivedPages, startPage + (totalVisible - 3));

                                                                            // Générer les boutons de page pour la plage calculée
                                                                            for (let i = startPage; i <= endPage; i++) {
                                                                                pageNumbers.push(
                                                                                    <li key={i} className={`page-item ${currentArchivedPage === i ? 'active' : ''}`}>
                                                                                        <button onClick={() => paginate(i)} className="page-link">{i}</button>
                                                                                    </li>
                                                                                );
                                                                            }

                                                                            // Ajouter des ellipses et la dernière page si nécessaire
                                                                            if (currentArchivedPage < totalArchivedPages - 2) {
                                                                                if (currentArchivedPage < totalArchivedPages - 3) {
                                                                                    pageNumbers.push(
                                                                                        <li key="ellipsis2" className="page-item disabled">
                                                                                            <span className="page-link">...</span>
                                                                                        </li>
                                                                                    );
                                                                                }

                                                                                pageNumbers.push(
                                                                                    <li key={totalArchivedPages} className="page-item">
                                                                                        <button onClick={() => paginate(totalArchivedPages)} className="page-link">{totalArchivedPages}</button>
                                                                                    </li>
                                                                                );
                                                                            }

                                                                            return pageNumbers;
                                                                        })()}

                                                                        <li className={`page-item ${currentArchivedPage === totalArchivedPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginateArchived(currentArchivedPage + 1)}>
                                                                                Next
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div >
                                        </div >
                                    </CCardBody >
                                </CCard >
                            </CCol >
                        </CRow >
                    </div >
                </div >
            )}
        </div >
    );
}

export default AppointmentList;